import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "@/components/layouts/PageContainer";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import { Button } from "@/components/button";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { useCreateGroup } from "@/apis/groups/createGroup";
import type { ICreateGroupRequest } from "@/apis/groups/createGroup";
import GroupForm from "./components/GroupForm";

const GroupCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const { mutate: createGroup, isPending, isError, error } = useCreateGroup();
  const [serverError, setServerError] = useState<string | undefined>();

  // 폼 제출 핸들러
  const handleSubmit = (formData: ICreateGroupRequest) => {
    // API 호출
    createGroup(formData, {
      onSuccess: (data) => {
        // 성공 시 상세 페이지로 이동
        if (data.data?.id) {
          navigate(`/groups/${data.data.id}`);
        } else {
          // 그룹 목록 페이지로 이동
          navigate("/groups");
        }
      },
      onError: (error: any) => {
        // 서버 오류 처리
        setServerError(error?.message || "Failed to create group");
      },
    });
  };

  // 목록 페이지로 돌아가기
  const handleCancel = () => {
    navigate("/groups");
  };

  return (
    <PageContainer>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Button plain onClick={handleCancel}>
            <ArrowLeftIcon className="h-5 w-5" />
            Back
          </Button>

          <div>
            <Heading>Create New Group</Heading>
            <Text className="text-zinc-500">
              Fill in the information below to create a new group.
            </Text>
          </div>
        </div>

        {/* 그룹 생성 폼 */}
        <div className="p-8 border border-gray-200 rounded-md bg-white">
          <GroupForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isLoading={isPending}
            serverError={serverError}
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default GroupCreatePage;
